import TranslationsConfigType from './translationType';

const nnTranslations: TranslationsConfigType = {
    confirmationScreen: {
        consumerLoanTitle: 'Forbrukslån',
        refinancingTitle: 'Refinansiering',
        creditCardTitle: 'Kredittkorta våre',
        title: 'Beregn pris og søk',
        description:
            '{} blir levert av Kredittbanken. For at Kredittbanken enkelt skal behandla søknaden din delar vi opplysningar om deg medan du søkjer.',
        toggleButtonText: 'Hvilke opplysningar blir delte?',
        listTitle: 'Du deler:',
        phone: 'telefonnummer',
        email: 'e-post',
        customerRelationship: 'stadfesting på at du er bankkunde hos oss',
        loanLinkText: 'Beregn pris og søk',
        creditCardLinkText: 'Søk om Eika kredittkort',
        eikaEmployeeCardLinkText: 'Søk om Eika Ansatt',
    },
    errors: {
        somethingWentWrong: 'Noko gjekk galt!',
        defaultMessage: 'Orsak, det oppstod ein teknisk feil. Ver vennleg og prøv igjen om ei tid.',
        errorCodeHeader: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
        informationModalTitle: 'Kva kan eg bruka feilkoden til?',
        informationModalDescription:
            'Når det oppstår ein feil, hender det ein blir nøydde til å kontakta banken for å få hjelp. Då er det veldig nyttig å ha ein feilkode banken kan få, så me lettare kan sjå kva som er gått gale. \n' +
            '\n' +
            'Ta eit skjermbilete av feilmeldinga eller les opp feilkoden til personen du pratar med på telefon. Skriv du med oss via meldingar i mobil- eller nettbank? Då kan du enkelt klikka «Kopiar feilkode», for deretter å lima han inn i meldingsvindauget til den banktilsette du skriv med.\n' +
            '\n' +
            'Sammen finn me ut av kva som har gått gale. Lykke til!',
    },
    goBack: 'Gå tilbake',
    nominalInterest: 'Nominell rente {}%',
    loanListTitle: 'Andre lån',
    loanOwners: {
        title: 'Låntakare',
        accountRole: {
            DEBTOR: 'Eier av lån',
            CO_DEBTOR: 'Medlåntakar',
            GUARANTOR: 'Kausjonist',
            UNKNOWN: 'Ukjent',
        },
    },
    loanDetails: {
        title: 'Detaljer',
        name: 'Namn på lån',
        intialAmount: 'Opprinnelig lånebeløp',
        maturityDate: 'Nedbetalingsdato',
        effectiveInterest: 'Effektiv rente',
        paymentDate: 'Forfallsdato',
        paymentDay: '{}. kvar månad',
        instalmentAmount: 'Terminbeløp',
    },
    loanInterest: {
        nominalInterest: 'Nominell rente',
        effectiveInterest: 'Effektiv rente {}%',
        loanRepaymentLinkTitle: 'Sjå nedbetalingsplan',
        loanRepaymentLinkDescription: 'Hos Kredittbanken',
    },
    loanOverview: {
        accountName: 'Kontonamn',
        accountNumber: 'Kontonummer',
        disposible: 'Disponibelt',
        moneyOnTheWay: 'Pengane er på veg. Det kan ta nokre verkedagar før pengane er utbetalte.',
        interest: 'Nominell rente',
        paymentDueDate: 'Neste innbetaling',
        instalmentAmount: 'Beløp',
        extraPayment: 'Ekstra innbetaling',
        more: 'Meir',
        changeDate: 'Endre forfall',
        seeDocuments: 'Sjå faktura og dokument',
        atKredittbanken: 'Hos Kredittbanken',
        infoKredittbankne: 'Forbrukslåna og kredittkorta våre blir leverte av Kredittbanken',
        showLoanAtKredittbanken: 'Sjå lånet ditt hos Kredittbanken',
        loanPayedDown: 'Lånet er nedbetalt',
    },
    transactions: {
        noTransactions: 'Her har det ikkje skjedd stort!',
        noMoreTransactionsToLoad: 'Det var alle transaksjonane på denne kontoen',
        reserved: 'Reservert',
        couldNotLoadMoreTransactions:
            'Orsak, grunna teknisk svikt klarte vi ikkje å laste fleire transaksjonar. Prøv igjen om ei tid.',
        tryAgain: 'Prøv om att',
    },
    creditCardScreen: {
        infoTitle: 'Du har allereie eit kredittkort hos oss',
        infoText: 'Du kan søkja om kredittgrense opp til 100 000 kr, eller søkja om eit nytt kredittkort',
        cardListTitle: 'Øyk kredittgrense',
        creditLimitText: 'Kredittgrensa di er {} kr',
        applyForCreditCardTitle: 'Søk om kredittkort',
        applyForEikaEmployeeTitle: 'Søk om Eika Ansatt Kredittkort',
        applyForEikaEmployeeCardText: 'For deg som ønskjer å skilja jobbrelaterte utgifter frå privatøknomien',
        blockedCreditLimit: 'Du kan ikkje søkja om auka kredittgrense på dette kortet',
        creditCardLimitErrorTitle: 'Du kan ikke søke om økt kredittgrense akkurat nå',
        creditCardLimitErrorText:
            'Det kan være flere grunner til det. Prøv igjen senere eller kontakt kundeservice hvis du trenger hjelp.',
        buttonOk: 'Ok',
    },
};

export default nnTranslations;
